<template>
  <div class="p-question__footer" ref="refFooter">
    <div class="c-accordion" ref="refAccordion">
      <div class="c-accordion__cont" :class="{'is-open':isOpen}">
        <div class="p-question__footer__inner">
          <slot name="helpTag"></slot>
          <slot name="prevButton"></slot>
          <!-- For compitable with NFR-4665 first tab key press and focus-->
          <span  :tabindex="0" id="dummy_focus"></span>
          <div v-if="answerList.length===1 && answerList[0].answer_format===quizTypes.NO_ANSWER" class="questionPageNoAnswer answerList">
            この問題は、ノートに手で書いて解答する問題です。答えを書いたらボタンを押して、答え合わせしましょう。
          </div>
          <ol class="answerList" v-else>
            <template v-for="(answer, index) in answerList">
              <template v-if="answer.answer_format===quizTypes.WRITTEN_RANDOM_ORDER">
                <li v-for="(item, idx) in answer.body.answersList" :key="'answer_'+index+'_'+idx"
                    :class="{
                      'math-field': isKeyboard,
                      'size size--half': answer.display_options.textInputFormat === layoutTypes.HALF,
                      'size size--countLength': answer.body.showCounter === true,
                      'is-focus':focusTextNum === answer.id+''+idx,
                      'judgeCorrect': workStore.isWronglyAnswered && initialAnswer.quiz_histories[index].sub_quizzes[idx].is_correct_answer
                      }"
                >
                  <div v-if="isKeyboard && answer.body.answersLabel && answer.body.answersLabel[idx]" class="number" v-html="labelText(answer.body.answersLabel[idx])"></div>
                  <span v-else-if="answer.body.answersLabel && answer.body.answersLabel[idx]" class="number">{{answer.body.answersLabel[idx]}}</span>
                  <div v-if="answer.body.showCounter" class="answerCountLengthText">
                    <p class="molecule">0</p>
                    <p class="denominator" v-if="answer.body.maxCharLimit">{{ answer.body.maxCharLimit }}</p>文字
                  </div>
                  <answer-text v-if="!answer.body.prefix&&!answer.body.suffix"
                               :answer="randomWrittenQuizGenerator(answer, idx)"
                               :is-souruby="isDebugSouruby"
                               :is-vertical="isVertical"
                               :is-keyboard="isKeyboard"
                               :is-science="isScience"
                               :text-limit="100"
                               :tab-index="tabIndex"
                               :prev-answer-text="initialAnswer.quiz_histories[index].sub_quizzes[idx].answer"
                               :prev-is-correct-answer="initialAnswer.quiz_histories[index].sub_quizzes[idx].is_correct_answer"
                               @press-enter="pressedEnterKey"
                               @set-is-focus="focusTextNum = $event"
                               @input-text="answerRandomDescriptiveValue(index, idx, $event)"
                  >
                  </answer-text>
                  <answer-pre-suffix-text v-if="answer.body.prefix||answer.body.suffix"
                                          :answer="randomWrittenQuizGenerator(answer, idx)"
                                          :is-souruby="isDebugSouruby"
                                          :is-vertical="isVertical"
                                          :is-keyboard="isKeyboard"
                                          :is-science="isScience"
                                          :text-limit="100"
                                          :tab-index="tabIndex"
                                          :prev-answer-text="initialAnswer.quiz_histories[index].sub_quizzes[idx].answer"
                                          :prev-is-correct-answer="initialAnswer.quiz_histories[index].sub_quizzes[idx].is_correct_answer"
                                          @press-enter="pressedEnterKey"
                                          @set-is-focus="focusTextNum = $event"
                                          @input-text="answerRandomDescriptiveValue(index, idx, $event)">
                  </answer-pre-suffix-text>
                </li>
              </template>
              <li v-else :key="'answer_'+index"
                  :class="{
                    'math-field': isKeyboard,
                    'size size--half': answer.display_options.textInputFormat === layoutTypes.HALF || answer.display_options.choicesLayout === layoutTypes.HALF,
                    'size size--countLength': answer.body.showCounter === true,
                    'size size--list': answer.answer_format === quizTypes.SELECT,
                    'is-focus':focusTextNum === answer.id,
                    'judgeCorrect': workStore.isWronglyAnswered && initialAnswer.quiz_histories[index].is_correct_answer
                    }">
                <div v-if="isKeyboard && answer.label.length > 0" class="number" v-html="labelText(answer.label)"></div>
                <span v-else-if="answer.label" class="number">{{answer.label}}</span>
                <div v-if="answer.body.showCounter" class="answerCountLengthText">
                  <p class="molecule">0</p>
                  <p class="denominator" v-if="answer.body.maxCharLimit">{{ answer.body.maxCharLimit }}</p>文字
                </div>
                <template v-if="answer.answer_format===quizTypes.DESCRIPTION">
                  <answer-text v-if="!answer.body.prefix&&!answer.body.suffix"
                               :answer="answer"
                               :is-souruby="isDebugSouruby"
                               :is-keyboard="isKeyboard"
                               :is-vertical="isVertical"
                               :is-science="isScience"
                               :tab-index="tabIndex"
                               :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                               :prev-is-correct-answer="initialAnswer.quiz_histories[index].is_correct_answer"
                               @press-enter="pressedEnterKey"
                               @set-is-focus="focusTextNum = $event"
                               @input-text="answerDescriptiveValue(index, $event)"
                  >
                  </answer-text>
                  <answer-pre-suffix-text v-if="answer.body.prefix||answer.body.suffix"
                                          :answer="answer"
                                          :is-souruby="isDebugSouruby"
                                          :is-vertical="isVertical"
                                          :is-keyboard="isKeyboard"
                                          :is-science="isScience"
                                          :tab-index="tabIndex"
                                          :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                                          :prev-is-correct-answer="initialAnswer.quiz_histories[index].is_correct_answer"
                                          @press-enter="pressedEnterKey"
                                          @set-is-focus="focusTextNum = $event"
                                          @input-text="answerDescriptiveValue(index, $event)">
                  </answer-pre-suffix-text>
                </template>
                <template v-if="answer.answer_format===quizTypes.SELECT">
                  <template v-if="workStore.isWronglyAnswered && initialAnswer.quiz_histories[index].is_correct_answer">
                    <answer-text
                        :answer="answer"
                        :is-souruby="isDebugSouruby"
                        :is-vertical="isVertical"
                        :is-keyboard="isKeyboard"
                        :is-science="isScience"
                        :tab-index="tabIndex"
                        :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                        :prev-is-correct-answer="initialAnswer.quiz_histories[index].is_correct_answer"
                        @set-is-focus="focusTextNum = $event"
                    >
                    </answer-text>
                  </template>
                  <template v-else>
                    <answer-radio-button
                        v-if="answer.display_options.choicesSelector === choiceTypes.BUTTON && isAnswerRadioType(answer.body.answers)"
                        :is-vertical="isVertical"
                        :is-souruby="isDebugSouruby"
                        :tab-index="tabIndex"
                        :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                        @input="answerRadioValue(index, $event)"
                        :answer="answer">
                    </answer-radio-button>
                    <answer-checkbox
                        v-else-if="answer.display_options.choicesSelector === choiceTypes.BUTTON && !isAnswerRadioType(answer.body.answers)"
                        :is-vertical="isVertical" :answer="answer"
                        :is-souruby="isDebugSouruby"
                        :tab-index="tabIndex"
                        :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                        v-model="checkboxValue[index]"
                        @input="answerCheckBoxValue(index, $event)">
                    </answer-checkbox>
                    <answer-select
                        v-else :answer="answer"
                        :is-vertical="isVertical"
                        :is-souruby="isDebugSouruby"
                        :tab-index="tabIndex"
                        :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                        :prev-is-correct-answer="initialAnswer.quiz_histories[index].is_correct_answer"
                        @set-tab-index="setTabIndex"
                        @focus-next-item="focusNextItem"
                        @select-value="answerSelectedValue(index, $event)"
                        :select-list-radio="isAnswerRadioType(answer.body.answers)" :answer-format-id="'button_'+index">
                    </answer-select>
                  </template>
                </template>
                <template v-if="answer.answer_format===quizTypes.SORTING">
                  <template v-if="workStore.isWronglyAnswered && initialAnswer.quiz_histories[index].is_correct_answer">
                    <answer-text
                        :answer="answer"
                        :is-souruby="isDebugSouruby"
                        :is-vertical="isVertical"
                        :is-keyboard="isKeyboard"
                        :is-science="isScience"
                        :tab-index="tabIndex"
                        :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                        :prev-is-correct-answer="initialAnswer.quiz_histories[index].is_correct_answer"
                        @set-is-focus="focusTextNum = $event"
                    >
                    </answer-text>
                  </template>
                  <template v-else>
                    <ul class="selectListCont">
                      <li v-for="(item, idx) in getSortAnswerList(answer.body.answers)" :key="'item' + idx">
                        <answer-select :answer="answer" :answer-format-id="`${idx}`" :select-list-radio="true"
                            :is-sorting="true"
                            :is-vertical="isVertical"
                            :is-souruby="isDebugSouruby"
                            :tab-index="tabIndex"
                            :prev-answer-text="restoreSortingData(index, idx)"
                            :prev-is-correct-answer="initialAnswer.quiz_histories[index].is_correct_answer"
                            @set-tab-index="setTabIndex"
                            @focus-next-item="focusNextItem"
                            @select-value="selectedValueSort(index, $event)">
                        </answer-select>
                      </li>
                    </ul>
                  </template>
                </template>
                <template v-if="answer.answer_format===quizTypes.MULTIPLE_CHOICE_RANDOM_ORDER">
                  <template v-if="workStore.isWronglyAnswered && initialAnswer.quiz_histories[index].is_correct_answer">
                    <answer-text
                        :answer="answer"
                        :is-souruby="isDebugSouruby"
                        :is-vertical="isVertical"
                        :is-keyboard="isKeyboard"
                        :is-science="isScience"
                        :tab-index="tabIndex"
                        :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                        :prev-is-correct-answer="initialAnswer.quiz_histories[index].is_correct_answer"
                        @set-is-focus="focusTextNum = $event"
                    >
                    </answer-text>
                  </template>
                  <template v-else>
                    <answer-checkbox
                        :is-vertical="isVertical"
                        :answer="answer" v-model="checkboxValue[index]"
                        :is-souruby="isDebugSouruby"
                        :tab-index="tabIndex"
                        :prev-answer-text="initialAnswer.quiz_histories[index].answer"
                        @input="answerCheckBoxValue(index, $event)">
                    </answer-checkbox>
                  </template> 
                </template>
              </li>
            </template>
          </ol>
          <button-blue @click="openJudgeModalTimeout" :tab-index="tabIndex" :is-vertical="isVertical" :arrow="!isVertical" :label-normal="true" :disabled="workStore.isDisabledButton" name="S3-7-next-question-btn">答え合わせ</button-blue>
        </div>
        <div class="codeText">
          qid:{{workStore.questions[questionIndex].work_id}}-{{workStore.questions[questionIndex].id}}
          <slot name="report"></slot>
        </div>
      </div>

      <div class="c-accordion__btn" :class="{'is-open':isOpen}">
        <div class="c-accordion__btn__inner" @click="open" name="S3-7-accordion-btn">
          <div class="c-accordion__btn__inner__box">
          </div>
        </div>
      </div>
      <!--For make focus cycle-->
      <span tabindex="0" @focus="focusFirstElement()"></span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {ref, onMounted, nextTick, computed} from 'vue';
  import {event} from "vue-gtag";
  import {CHOICETYPE, GRADINGMETHOD, LAYOUT, QUIZTYPE} from "@/consts/answer_column";
  import {CHOICESLABEL} from "@/consts/choicesLabel";
  import { markdown as md } from "@/util/markdown";
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env";
  import {deleteEmptySpace} from "@/util/remove_all";
  import {DISABLED_BUTTON_TIME, COMPOSING_CHECK_TIME, COMPOSING_TIMEOUT} from "@/consts/study"
  import NormalizeAnswers from "@/util/normalize_answers"
  import { useWorkStore } from '@/store/student/work_store';
  import * as Sentry from "@sentry/browser";

  const props = withDefaults(
    defineProps<{
      isDebugSouruby?: boolean | null;
      isVertical?: boolean;
      isStudent?: boolean; // this props is for activate gtag for student only
      questionIndex?: number;
    }>(),
    {
      isDebugSouruby: false,
      isVertical: false,
      isStudent: true,
      questionIndex: 0,
    }
  );
  
  const emit = defineEmits<{
    (e: 'body-height'): void,
    (e: 'go-next', id: string): void,
  }>()

  const workStore = useWorkStore()
  const isOpen = ref(true)
  const refAccordion = ref(null)
  const refFooter = ref(null)
  const verticalAccordionWidth = ref(0)
  const focusTextNum = ref<number|string>(0)
  const checkboxValue = ref(Array.from({length: 10}, (_, i) => []))
  const selectedValueList = ref(Array.from({length: 10}, (_, i) => []))
  const selectedAnswerIndexArray = ref(Array.from({length: 10}, (_, i) => null))
  // work with keyboard tab key press
  const tabIndex = ref(0)
  // NFR-5190 state取得して別の変数に格納して使用する。
  const question = workStore.questions[props.questionIndex]
  const initialAnswer = workStore.initialAnswer[props.questionIndex]
  const answerList = question.quizzes
  const selectedWork = workStore.selectedWork[workStore.selectedWorkIndex]
  const workId = selectedWork.id
  const quizTypes = QUIZTYPE
  const choiceTypes = CHOICETYPE
  const layoutTypes = LAYOUT
  const subjectField = selectedWork.subject_field
  const isKeyboard = computed(() => {
    return subjectField === '理科' || subjectField === '数学'
  })
  const isScience = computed(() => {
    return subjectField === '理科'
  })
  const isMath = computed(() => {
    return subjectField === '数学'
  })
  const isJapanese = computed(() => {
    return subjectField === '国語'
  })
  const isSociety = computed(() => {
    return selectedWork.subject.name === '社会'
  })

  onMounted(() => {
    if(props.isVertical){ // 縦書きの時フッターとアコーディオン幅が違う問題があるので別の処理をする。NFR-2618対応
      accordionWidth()
    }
    // adjust body height after render
    emit("body-height")
    // NFR-4665 should not auto focus if selective and multiple selective without sorting format with display_format as button
    let focusCondition = false
    try {
      focusCondition = answerList.length && 
                      (answerList[0].answer_format === QUIZTYPE.SELECT || 
                      answerList[0].answer_format === QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER) && 
                      answerList[0].display_options.choicesSelector === CHOICETYPE.BUTTON
    } catch (error) {
      focusCondition = false
      Sentry.captureMessage("Quiz Render error", "warning")
    }
    if(focusCondition) {
      // focus dummy focus element so for first tab press will focus the next focussable element
      let elem = document.getElementById("dummy_focus") as HTMLElement
      if(elem) {
        elem.focus()
      }
    }else{
      focusFirstElement()
    }
    setTimeout(async() => {
      // NFR-3683 非活性されたボタンを500ミリ秒以降に活性化する
      workStore.saveIsDisabledButton(false)
    }, DISABLED_BUTTON_TIME)

    // NFR-5442 間違えた問題だけ再チャレンジを解く時、選択式・順不同記述式の正答を正しく表示するためsplitしてinitialAnswerに保存
    if (workStore.isWronglyAnswered) {
      const quiz_histories = initialAnswer.quiz_histories;
      quiz_histories.forEach((item, index) => {
        // 正答のみ処理を続く
        if (item.is_correct_answer) {
          const quiz = question.quizzes[index];
          if(quiz.answer_format == QUIZTYPE.SELECT || quiz.answer_format == QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER){
            let answers = [item.answer][0].split(' ／ ');
            const answerTexts = [];
            // choicesLabelが原文のままではない場合、正しい表示のため設定した別のラベル値から原文のラベル値を取得して渡す。
            if(quiz.display_options.choicesLabel !== 1){
              answers.forEach(userAnswer => {
                const index_ = CHOICESLABEL[quiz.display_options.choicesLabel].indexOf(userAnswer);
                if (index_ !== -1 && index_ < quiz.body.answers.length) {
                  const answerText = quiz.body.answers[index_]["answerText"];
                  answerTexts.push(answerText);
                }
              })
              answers = answerTexts
            }
            answerDescriptiveValue(index, answers);
          }
        }
      });
    }
  })
  
  function restoreSortingData(index: number, idx: number){
    let answer:any = initialAnswer.quiz_histories[index].answer
    answer = answer.split(isJapanese.value?'⇓':'⇒')
    if(answer[idx]){
      return answer[idx]
    }
    return ""
  }
  function setTabIndex(value) {
    tabIndex.value = value
  }
  function getKeyboardFocusableElements (element) {
    // NFR-5262 要素がnullまたはundefinedの場合は空の配列を返す
    if (!element) {
      return [];
    }
    return [...element.querySelectorAll(
      'a.c-button-blue, [tabindex]:not([tabindex="-1"])'
    )]
      .filter(el => !el.hasAttribute('disabled'))
  }
  function pressedEnterKey(focusElement: any = null) {
    if(focusElement === null){
      focusElement = document.activeElement
    }
    const focusableElements = getKeyboardFocusableElements(refAccordion.value)
    let isNextFocus: boolean = false
    for(const focusItem of focusableElements){
      if(isNextFocus){
        focusItem.focus()
        break
      }
      if(focusItem === focusElement){
        isNextFocus = true
      }
    }
  }
  // auto focus next item after press ok from select-box
  function focusNextItem(focusElement: any) {
    nextTick(() => pressedEnterKey(focusElement))
  }

  function focusFirstElement() {
    const focusableElements = getKeyboardFocusableElements(refAccordion.value)
    let focusIndex = 1
    let found = false;
    // NFR-5262 フォーカス可能な要素が少なくとも2つあるかチェック
    if (focusableElements.length <= 1) {
      return;
    }
    // NFR-5442 間違えた問題だけ再チャレンジを解く時は誤答の解答欄にフォーカスを付与
    if(workStore.isWronglyAnswered){
      for (let i = 0; i < focusableElements.length; i++){
        if(focusableElements[i].dataset?.prevIsCorrectanswer === 'false'){
          focusIndex = i
          found = true
        }
        if(found){
          break
        }
      }
      focusableElements[focusIndex].focus()
    }else{
      focusableElements[1].focus()
    }
  }
  // ipadでフッターとアコーディオン幅が違って画面にはみ出すことがある。それを同じく調整する。PCはいつも両方幅が同じなのでこの処理を一緒に使っても問題ない。
  function accordionWidth(){
    setTimeout(()=>{
      if(refFooter.value && refAccordion.value && refFooter.value.clientWidth != refAccordion.value.clientWidth){ // 普通はフッターとアコーディオン幅が同じことが正しいか、ipadだけ違う場合がある。それを同じく設定
        refFooter.value.style.width = refAccordion.value.style.width = refAccordion.value.clientWidth + 'px'
      }
      verticalAccordionWidth.value = refAccordion.value?.clientWidth || 0 // アコーディオン開閉の時使うためアコーディオン幅を保存
    },20)
  }
  function open() {
    isOpen.value = !isOpen.value
    if (props.isVertical) {
      if (!isOpen.value) {
        refFooter.value.style = ""
        refAccordion.value.style = ""
      }else{
        refFooter.value.style.width = refAccordion.value.style.width = verticalAccordionWidth.value + 'px'
      }
    }
    emit("body-height")
  }

  function labelText(text: string){
    return md.render(text);
  }
  function randomWrittenQuizGenerator(answer, idx){
    return {
      id: answer.id+''+idx,
      answer_format: answer.answer_format,
      grading_format: answer.grading_format,
      label: answer.label,
      display_options: answer.display_options,
      body: answer.body,
      sort_order: answer.sort_order
    }
  }

  function isAnswerRadioType(answers){
    return answers.filter(v=>v.isCorrectAnswer === true).length === 1
  }

  function getSortAnswerList(answers){
    return answers.filter(v=>v.answerOrder > 0)
  }

  function answerDescriptiveValue(quiz_index, text){
    // 該当するquiz indexの解答欄を取得
    let quiz = question.quizzes[quiz_index]
    // 解答欄が選択式、または順不問選択式の場合実行
    if(quiz.answer_format == QUIZTYPE.SELECT || quiz.answer_format == QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER){
      let index_array = []
      let answers_array = []
      quiz.body.answers.forEach((q, answer_index) => {
        let result = text.some(v => v == q.answerText)
        if (result) {
          if(quiz.display_options.choicesLabel !== 1){
            answers_array.push(CHOICESLABEL[quiz.display_options.choicesLabel][answer_index])
          }
          index_array.push(answer_index) // 選択した答えのanswer indexを配列に入れる
        }
      })
      if(quiz.display_options.choicesLabel !== 1){
        text = answers_array.join(" ／ ")
      }else{
        text = text.join(" ／ ")
      }
      selectedAnswerIndexArray.value[quiz_index] = {quiz_id:quiz.id, selected_index:index_array}
    }
    // set answer value in store via emit
    workStore.saveAnswerValue({id: quiz_index, text:text})
  }
  // answerRadioValue,answerCheckBoxValue,answerSelectedValueのvalueはarrayの形で値を渡す。
  // 選択した答えのindexを取得するため
  function answerRadioValue(index, value){
    answerDescriptiveValue(index, [value])
  }
  function answerCheckBoxValue(index, value){
    checkboxValue.value[index]  = value
    answerDescriptiveValue(index, value)
  }
  function answerSelectedValue(index, value){
    if(value && value.value){ // セレクトボックスのラジオボタン
      answerDescriptiveValue(index, [value.value])
    }
    else { // セレクトボックスのチェックボックス
      answerDescriptiveValue(index, value)
    }
  }
  function answerRandomDescriptiveValue(index, idx, value){
    workStore.saveRandomWrittenAnswerValue({id: index, sub_id: idx, text:value})
  }
  // 並び替え
  function selectedValueSort(index, e){
    if(e.length === 0){
      return
    }
    let result:boolean = false // 同じ選択欄かどうか
    let element_index:number = 0 // 選択した選択肢のindex位置
    selectedValueList.value[index].forEach((item, position) =>{
      if(item.format_id === e.format_id){
          result = true
          element_index = position
        }
    })
    if(result){
      // 同じ選択欄で選択肢を切り替える
      selectedValueList.value[index].splice(element_index, 1, e)
    }else{
      selectedValueList.value[index].push(e) // 違う選択欄の場合そのままリストに追加
      selectedValueList.value[index].sort(function(a,b){ // 並び替え選択欄順でソートする
          return a.format_id < b.format_id ? -1 : 1
        })
    }
    let selectedList = selectedValueList.value[index].map(v=>v.value).join(isJapanese.value?'⇓':'⇒')
    answerDescriptiveValue(index, selectedList)
  }
  // NFR-2351対応
  function openJudgeModalTimeout(pointerType: string){
    // send google analytics pointerType event(value: pen|mouse|touch)
    if(pointerType && isEnvCaptureGoogleAnalyticsEvents() && props.isStudent){
      event('pointer_type', {
        'pointer_type': pointerType
      })
    }
    if(isKeyboard.value){
      checkComposing()
    }else{
      openJudgeModal()
    }
  }
  // NFR-4550対応 ipadで数学・理科の日本語入力で確定せずに「答え合わせ」ボタンを押しても値がちゃんと表示できるように対応
  function checkComposing(){
    let interval:number;
    let timeout:number;
    const checkCompositionInProgress = () => {
        if (!workStore.compositionInProgress) {
            // compositionInProgressがfalseになったら処理を実行
            openJudgeModal();
            clearInterval(interval); // 監視を停止
            clearTimeout(timeout); // タイムアウトもクリア
        }
    };
    // 100msごとにcompositionInProgressをチェック
    interval = setInterval(checkCompositionInProgress, COMPOSING_CHECK_TIME);
    // 5000ms後にもcompositionInProgressがtrueの場合、監視を中止して正誤判定処理を実行
    timeout = setTimeout(() => {
        if (workStore.compositionInProgress) {
          Sentry.withScope(function(scope) {
            // NFR-4610 question_idを送信する。（調査をしやすくするため）
            scope.setContext("Japanese Input Conversion Info", {
              question_id: question.id
            });
            scope.setLevel("log");
            Sentry.captureMessage("日本語入力変換が完了になるまで5秒かかる");
          });
          clearInterval(interval); // 監視を停止  
          workStore.saveCompositionInProgress(false)
          openJudgeModal();
        }
    }, COMPOSING_TIMEOUT);
  }
  async function openJudgeModal(){
    workStore.saveIsDisabledButton(true)
    // set router transit start time
    workStore.saveTransitTime(Date.now())
    const normalize = new NormalizeAnswers() // user_answer,quiz_answerの正規化処理は別module化する。
    // 手動採点かつ解答欄が記述式の場合（手動採点は基本記述式のみ）
    if(answerList.length == 1 && answerList[0].answer_format==QUIZTYPE.DESCRIPTION && answerList[0].grading_format==GRADINGMETHOD.MANUAL){
      let answer_text = initialAnswer.quiz_histories[0].answer
      // NFR-5920: fetch removeTrailingZeroSigFigs from quiz body
      const remove_trailing_zero_sig_figs = answerList[0].body?.removeTrailingZeroSigFigs || false
      answer_text = normalize.normalizeUserAnswer(answer_text, remove_trailing_zero_sig_figs)
      // get the example answer
      let example_answer = answerList[0].body?.exampleAnswer || ""
      // 何か答えを入力した場合は手動採点ページに移動
      if(answer_text.length > 0){
        // normalize the question example answer for comparision
        example_answer = normalize.normalizeQuizAnswer(example_answer, remove_trailing_zero_sig_figs)
        // NFR-3955 S3-7で模範解答と同じ答えを書いた時、手動採点問題であっても自動で正解にしたい
        if(answer_text == example_answer){
          workStore.saveQuizCorrectAnswer({id: 0, is_correct: true})
          workStore.saveQuestionCorrectAnswer(true)
          workStore.saveSingleQuestionCorrectWrongList({result: true, progress: 1})
          workStore.saveQuestionStudyEndTime()
          if(isEnvCaptureGoogleAnalyticsEvents() && props.isStudent){
            event('answer_is_correct', {
              'work_id': workId,
              'question_id': question.id,
              'question_index': props.questionIndex + 1
            })
          }
          emit("go-next", "answer")
        }else{
          emit("go-next", "judge")
        }
      }else{ // 何も入力されない場合は自動採点ページに移動
        workStore.saveQuizCorrectAnswer({id: 0, is_correct: false})
        workStore.saveQuestionCorrectAnswer(false)
        workStore.saveSingleQuestionCorrectWrongList({result: false, progress: 1})
        workStore.saveQuestionStudyEndTime()
        if(isEnvCaptureGoogleAnalyticsEvents() && props.isStudent){
          event('answer_is_incorrect', {
            'work_id': workId,
            'question_id': question.id,
            'question_index': props.questionIndex + 1
          })
        }
        emit("go-next", "answer")
      }
    }
    // for no answer
    else if(answerList.length == 1 && answerList[0].answer_format==QUIZTYPE.NO_ANSWER){
      workStore.saveAnswerValue({id: 0, text:"（この問題は、ノートに手で書いて解答した問題です。）"})
      emit("go-next", "judge")
    }
    // 自動採点の場合
    else{
      let quizzes = JSON.parse(JSON.stringify(question.quizzes))
      let initial_answer = initialAnswer.quiz_histories
      let answers_dict = setDictAnswers(quizzes,initial_answer) // user_answerとquiz_answerをquiz_idごとにまとめる
      let count_correct = 0 // 正解したquizの数
      let math_calculate_data = {}  // save math_calculate api request data
      let quizId_userAnswerIndex_map = {}  // map quiz_id with user_answer index, quiz index and sub-quizzes

      for(let q_id in answers_dict){
        quizId_userAnswerIndex_map[q_id] = []
        const quizId = parseInt(q_id)
        const quizItem = quizzes.find(item=>item.id===quizId)
        const userAnswerIndex = initial_answer.findIndex(item=>item.quiz_id === quizId)
        // NFR-5920: fetch removeTrailingZeroSigFigs from quiz body
        const remove_trailing_zero_sig_figs = quizItem.body?.removeTrailingZeroSigFigs || false
        
        let q_answers = answers_dict[q_id]
        let userAnswerItem = initial_answer.find(item=>item.quiz_id === quizId)
        let random_correct_count: number = 0 // 順不問記述式で正解したsub_quizの数

        for(let index in q_answers){
          // 正規化される前のユーザー解答保存（社会教科のため）
          let original_user_answer = q_answers[index].user_answer[0]
          let q_answer = q_answers[index]

          // 解答欄が記述式の場合
          if(quizItem.answer_format == QUIZTYPE.DESCRIPTION){
            let answer_no_space = false 
            // 問題解答正規化
            for(let i in q_answer.quiz_answer){
              q_answer.quiz_answer[i] = normalize.normalizeQuizAnswer(q_answer.quiz_answer[i], remove_trailing_zero_sig_figs)
              // 正解ですべて連続した文字列があるかチェック
              if(isSociety.value && !q_answer.quiz_answer[i].includes(' ')){
                answer_no_space = true
              }
            }
            // ユーザー解答正規化
            q_answer.user_answer[0] = normalize.normalizeUserAnswer(q_answer.user_answer[0], remove_trailing_zero_sig_figs)
            
            // 正誤判定処理
            const isAnswerIncluded = q_answer.user_answer.some(answer => q_answer.quiz_answer.includes(answer));
            if(isAnswerIncluded){
              count_correct++
              workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: true})
            }else{
              // 数学の場合、文字列一致で不正解になったら計算APIを呼び出す。
              if(isMath.value && quizItem.body.checkFormulaAsString === false && q_answer.user_answer[0].length>0){
                math_calculate_data[q_id] = {
                  "quiz_answer": q_answer.quiz_answer,
                  "user_answer": q_answer.user_answer[0]
                }
                quizId_userAnswerIndex_map[q_id].push({"userAnswerIndex": userAnswerIndex})
              }
              // 社会の場合、基本正規化の文字列一致で不正解になったら別途の正誤判定処理を行う
              else if(isSociety.value && q_answer.user_answer.length > 0){
                // 正規化されたユーザー解答がすべて連続した文字列の場合、正解のみ空白を除去する。
                if(!q_answer.user_answer[0].includes(' ')){
                  for(let i in q_answer.quiz_answer){
                    q_answer.quiz_answer[i] = deleteEmptySpace(q_answer.quiz_answer[i])
                  }
                }
                // 正解がすべて連続した文字列の場合、正規化される前のユーザー解答で空白を除去する。区切り文字=・は誤答になる。
                if(answer_no_space){
                  q_answer.user_answer[0] = deleteEmptySpace(original_user_answer)
                }
                const isAnswerIncluded = q_answer.user_answer.some(answer => q_answer.quiz_answer.includes(answer));
                if(isAnswerIncluded){
                  count_correct++
                  workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: true})
                }else{
                  workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: false})
                }
              }else{
                workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: false})
              }
            }

          }
          // 解答欄が選択式、または順不問選択式の場合
          else if(quizItem.answer_format == QUIZTYPE.SELECT || quizItem.answer_format == QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER){
            // 選択した答えと正解が一致するかチェック
            const isMatch = (q_answer.user_answer.length === q_answer.quiz_answer.length) && q_answer.user_answer.every((value)=>q_answer.quiz_answer.includes(value))
            if(isMatch){
              count_correct++
              workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: true})
            }else{
              workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: false})
            }
          }
          // 解答欄が並び替えの場合
          else if(quizItem.answer_format == QUIZTYPE.SORTING){
            // 選択した答えと正解が一致するかチェック
            const isMatch = q_answer.user_answer[index] === q_answer.quiz_answer[index]
            if(isMatch){
              count_correct++
              workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: true})
            }else {
              workStore.saveQuizCorrectAnswer({id: userAnswerIndex, is_correct: false})
            }
          }
          // 解答欄が順不問記述式の場合
          else if(quizItem.answer_format == QUIZTYPE.WRITTEN_RANDOM_ORDER){
      
            // 問題解答正規化
            for(let i in q_answer.quiz_answer){
              for(let j in q_answer.quiz_answer[i]){
                  q_answer.quiz_answer[i][j] = normalize.normalizeQuizAnswer(q_answer.quiz_answer[i][j], remove_trailing_zero_sig_figs)
              }
            }
            // ユーザー解答正規化
            q_answer.user_answer[0] = normalize.normalizeUserAnswer(q_answer.user_answer[0], remove_trailing_zero_sig_figs)

            // 正誤判定処理
            let is_correct = false
            for(let i in q_answer.quiz_answer){
              if(q_answer.quiz_answer[i].includes(q_answer.user_answer[0])){
                is_correct = true
                q_answer.quiz_answer.splice(i, 1)
                break
              }
            }
            if(is_correct){
              userAnswerItem.sub_quizzes[index].is_correct_answer = true
              random_correct_count++
            }
            else{
              // 数学の場合、文字列一致で不正解になったら計算APIを呼び出す。
              if(isMath.value && quizItem.body.checkFormulaAsString === false && q_answer.user_answer[0].length>0){
                if(math_calculate_data[q_id]){
                  math_calculate_data[q_id].user_answer.push(q_answer.user_answer[0])
                } else {
                  math_calculate_data[q_id] = q_answer
                }
                quizId_userAnswerIndex_map[q_id].push({"userAnswerIndex": userAnswerIndex, "index": index, "sub_quizzes": userAnswerItem.sub_quizzes})
              }
              // 社会の場合、文字列一致で不正解になったら別途の処理を行う
              else if (isSociety.value){
                // 順不問記述式はループしてユーザー解答と一致するのを探すため条件によって空白を消したりする。
                // その時オリジナル正答を変更すると次にループした値が変更された正答と比較するので変更される正答はコピーした配列にいれる。
                let copy_quiz_answer = JSON.parse(JSON.stringify(q_answer.quiz_answer))
                let con_text_ = q_answer.user_answer[0];
                for(let i in q_answer.quiz_answer){
                  for(let j in q_answer.quiz_answer[i]){
                    // 正規化されたユーザー解答がすべて連続した文字列の場合、正解のみ空白を除去する。
                    if(!q_answer.user_answer[0].includes(' ')){
                      copy_quiz_answer[i][j]=deleteEmptySpace(q_answer.quiz_answer[i][j])
                    }
                    // 正解がすべて連続した文字列の場合、正規化される前のユーザー解答で空白を除去する。区切り文字=・は誤答になる。
                    if(!q_answer.quiz_answer[i][j].includes(' ')){
                      con_text_ = deleteEmptySpace(original_user_answer)
                    }
                  }
                  if(copy_quiz_answer[i].includes(con_text_)){
                    is_correct = true
                    q_answer.quiz_answer.splice(i, 1)
                    copy_quiz_answer.splice(i,1)
                    break
                  }
                }
                if(is_correct){
                  userAnswerItem.sub_quizzes[index].is_correct_answer = true
                  random_correct_count++
                }
              }
            }
            if(q_answers.length === random_correct_count){
              workStore.saveRandomQuizCorrectAnswer({id: userAnswerIndex, is_correct: true, sub_quizzes: userAnswerItem.sub_quizzes})
              count_correct++
            }else{
              workStore.saveRandomQuizCorrectAnswer({id: userAnswerIndex, is_correct: false, sub_quizzes: userAnswerItem.sub_quizzes})
            }
          }
        }
      }
      if(Object.keys(math_calculate_data).length) {
        // call math calculation api
        let response = await workStore.fetchMathCalculation(math_calculate_data)
        for(let quiz_id in response.data){
          // check random written format
          if(Array.isArray(math_calculate_data[quiz_id].quiz_answer[0])){
            // if all random question are true then count_correct answer
            let isAllCorrect = response.data[quiz_id].every(item => item.is_correct)
            if(isAllCorrect){
              count_correct++
            }
            for(let i in response.data[quiz_id]){
              // set sub_quizzes after api call
              quizId_userAnswerIndex_map[quiz_id][0].sub_quizzes[quizId_userAnswerIndex_map[quiz_id][i].index].is_correct_answer = response.data[quiz_id][i].is_correct
            }
            // save randomQuiz status wrong or right
            workStore.saveRandomQuizCorrectAnswer({id: quizId_userAnswerIndex_map[quiz_id][0].userAnswerIndex, is_correct: isAllCorrect, sub_quizzes: quizId_userAnswerIndex_map[quiz_id][0].sub_quizzes})
          }
          // description format 
          else {
            if(response.data[quiz_id][0].is_correct){
              // count correct answer
              count_correct++
            }
            // change the right or wrong status for descriptive quiz
            workStore.saveQuizCorrectAnswer({id: quizId_userAnswerIndex_map[quiz_id][0].userAnswerIndex, is_correct: response.data[quiz_id][0].is_correct})
          }
        }
      }
      // 小問の解答欄全部正答の場合は正誤情報欄にtrueを設定
      if(answers_dict && Object.keys(answers_dict).length === count_correct){
        workStore.saveQuestionCorrectAnswer(true)
        workStore.saveSingleQuestionCorrectWrongList({result: true, progress: 1})
        if(isEnvCaptureGoogleAnalyticsEvents() && props.isStudent){
          event('answer_is_correct', {
            'work_id': workId,
            'question_id': question.id,
            'question_index': props.questionIndex + 1
          })
        }
      }else{ // 小問の解答欄全部正答ではない場合は正誤情報欄にfalseを設定
        workStore.saveQuestionCorrectAnswer(false)
        workStore.saveSingleQuestionCorrectWrongList({result: false, progress: 1})
        if(isEnvCaptureGoogleAnalyticsEvents() && props.isStudent){
          event('answer_is_incorrect', {
            'work_id': workId,
            'question_id': question.id,
            'question_index': props.questionIndex + 1
          })
        }
      }
      workStore.saveQuestionStudyEndTime()
      emit("go-next", "answer")
    }
  }
  // quiz_idをキーにuser_answerとquiz_answerをまとめる。
  function setDictAnswers(quizzes,initial_answer){
    // quiz_answerをまとめる
    const dict = {};
    quizzes.forEach(quiz => {
      const quizId = quiz.id;
      const answerFormat = quiz.answer_format;
      const quizAnswer = [];

      // 解答欄が選択式、または順不問選択式の場合
      if (answerFormat === QUIZTYPE.SELECT || answerFormat === QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER) {
        quiz.body.answers.forEach((answer, index) => {
          if (answer.isCorrectAnswer) {
            quizAnswer.push(index) // 正解のindexを配列に設定。
          }
        })
      }
      // 解答欄が並び替えの場合
      else if (answerFormat === QUIZTYPE.SORTING) {
        let item = JSON.parse(JSON.stringify(quiz.body.answers.filter(v => v.answerOrder > 0)))
        let answer = item.sort(function (a, b) { return a.answerOrder - b.answerOrder }).map(i => i.answerText).join(isJapanese.value ? '⇓' : '⇒')
        quizAnswer.push(answer)
      }
      // 解答欄が順不問記述式の場合
      else if (answerFormat === QUIZTYPE.WRITTEN_RANDOM_ORDER) {
        quiz.body.answersList.forEach(newAnswerList => {
          quizAnswer.push(newAnswerList);
        });
      }
      // その以外の場合
      else {
        quizAnswer.push(...quiz.body.answers);
      }

      // user_answerをまとめる
      dict[quizId] = [];
      initial_answer.forEach(answer => {
        if (answer.quiz_id === quizId) {
          const userAnswer = [];
          // 解答欄が選択式、または順不問選択式の場合
          if (answerFormat === QUIZTYPE.SELECT || answerFormat === QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER) {
            const foundAnswer = selectedAnswerIndexArray.value.find(answer => answer && answer.quiz_id === quizId)
            if (foundAnswer) {
              userAnswer.push(...foundAnswer.selected_index)
            }
          }
          // 解答欄が順不問記述式の場合
          else if (answerFormat === QUIZTYPE.WRITTEN_RANDOM_ORDER && answer.sub_quizzes) {
            answer.sub_quizzes.forEach(subQuiz => {
              userAnswer.push(subQuiz.answer);
              dict[quizId].push({ user_answer: [subQuiz.answer], quiz_answer: quizAnswer });
            });
          }
          // その以外の場合
          else {
            userAnswer.push(answer.answer);
          }
          if (answerFormat !== QUIZTYPE.WRITTEN_RANDOM_ORDER) {
            dict[quizId].push({ user_answer: userAnswer, quiz_answer: quizAnswer });
          }
        }
      });
    });
    return dict
  }
</script>
